

import analytics from '../analytics';

function reinsuranceCartOnLoad() {
    $(window).on('load', function () {
        reinsuranceWrapperReady();
    });
}

function reinsuranceCartOnDocumentReady() {
    $(document).ready(function () {
        reinsuranceWrapperReady();
    });
}

function reinsuranceWrapperReady() {
    $('.reinsurance-wrapper-cart').each(function () {
        if(!$(this).parent().hasClass('open-reinsurance-panel')) {
            if ($(this).find('.reinsuranceDesc').length === 0) {
                $(this).addClass('remove-plus-icon');
                $(this).prop('disabled', true);
            }
        }
    });
    if (($('#cart-items-form .reinsurance-wrapper-cart.mobile-only').length === 2) || $('.cart-empty-container-redesign .reinsurance-wrapper-cart.mobile-only').length === 2) {
        $(this).each(function () {
            $('.reinsurance-wrapper-cart.mobile-only').parents('.content-asset').addClass('flex-ease');
        })
    }
}

function reinsuranceCartClickEvent() {
    $('body').on('click', '.reinsurance-element', function (e) {
        e.stopImmediatePropagation();
        if($(this).hasClass('open-reinsurance-panel')) {
            const $this = $(this);
		    const clickedIndex = $(".reinsurance-element").index(this);
            $(this).prop('disabled', false);
            var contentAssetId = $(this).attr('data-content-id');
            openReinsurancePanel(contentAssetId);
            analytics.reinsuranceCheckoutDatalayer($this, clickedIndex);
        } else {
            $(this).toggleClass('show-description');
            $(this).siblings().toggleClass('hidden');
            $(this).parents('.content-asset').toggleClass('flex-ease');
            $('.reinsurance-wrapper-cart').not(this).removeClass('show-description');
        }
    });
    $(document).on('click', '.reinsurance-checkout-mobile .mobile-only', function (e) {
        e.stopImmediatePropagation();
        if($(this).parent().hasClass('open-reinsurance-panel')) {
            $(this).prop('disabled', false);
            var contentAssetId = $(this).parent().attr('data-content-id')
            openReinsurancePanel(contentAssetId);
        } else {
            if ($(this).find('.reinsuranceDesc').length === 0) {
                $(this).on('click', function (event) {
                    event.preventDefault();
                });
            } else {
                $('.reinsurance-checkout-mobile .mobile-only').not(this).toggleClass('hidden');
            }
        } 
    });
}

function reinsuranceCartClickResize() {
    $(window).on('resize orientationchange', function () {    
        reinsuranceCartClickEvent();
    });
}

// reinsurance popup for PDP & Cart page
function checkoutReinsurancePopup(dataContent) {
    $('a.cart-reinsuance-modal').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var $this = $(this);
        analytics.reinsuranceElements($this.attr('id'));

        $.ajax({
            url: util.appendParamToURL($this.attr('href'), 'format', 'ajax'),
            method: 'GET'
        })
            .done(function (response) {
                if (response) {
                    customModal.createCustomModal('checkout-reinsurance-popup', '#modal-custom-placeholder');
                    $('.checkout-reinsurance-popup').find('.modal-body').html(response);
                    if ($(window).width() > 768) {
                        $('.checkout-reinsurance-popup').find('.modal-body').scrollBox();
                        $(window).trigger("resize.scrollBox");
                    }
                }
            });
    });
}

function handleReinsuranceButtons() {
    $(document).on('click', '.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no', function () {
        $(this).addClass("activeReinsuranceRatingButton");
        $('.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no').css("pointer-events", "none");
    });
}

function closeReinsurance() {
    const $reinsurancePanel = $('.reinsurance-panel');
    const $reinsuranceOverlay = $reinsurancePanel.find('.panel-overlay');
    $(document).on('click', '.reinsurance-panel .panel-overlay, .reinsurance-panel .icon-close', function (e) { // document click to close reinsurance panel as avoid binding off and on click with parent element as that sometime not work properly
        const $this = $(this);
        const $panel = $this.closest('.reinsurance-panel');
        const isCloseIcon = $this.hasClass('icon-close');
        const isOverlay = $reinsuranceOverlay.length && $this.is($reinsuranceOverlay);

        if (isOverlay) e.stopPropagation();

        $panel.removeClass('opened');

        if (isCloseIcon) {
            setTimeout(function () {
                $reinsurancePanel.removeAttr('style');
            }, 500);
        }

        $('html').removeClass('filter-open');
    });
}

function openReinsurancePanel(contentAssetId) {
    const $reinsurancePanel = $('.reinsurance-panel');
    const $panelBodyElelement = $reinsurancePanel.find('.panel-body');
    const $panelBodyContent = $panelBodyElelement.find('.panel-body-content');
    const isTablet = window.matchMedia("(max-width: 768px)").matches;
    $.ajax({
        url: Urls.displayReinsuranceOverlay + '?cid=' + contentAssetId,
        type: 'GET'
    }).done(function (response) {
        $reinsurancePanel.removeAttr('style').addClass('opened');
        $('html').addClass('filter-open');
        $reinsurancePanel.find('.panel-header h3').html(response.name);
        $panelBodyContent.html(response.content);
        $('.panel-content-buttons .panel-bottom-yes, .panel-content-buttons .panel-bottom-no')
            .removeClass("activeReinsuranceRatingButton")
            .css("pointer-events", "auto");
        const panelHeight = $(".reinsurance-panel .panel-wrapper").height();
        if (isTablet) {
            var panelBodyHeight = $panelBodyContent.height() + 240;
        } else {
            var panelBodyHeight = $panelBodyContent.height() + 220;
        }

        if (panelBodyHeight > panelHeight) {
            $panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'static',
                'margin-bottom': '0'
            });
        } else {
            $panelBodyElelement.find('.panel-bottom-content').css({
                'position': 'absolute',
                'margin-bottom': '40px'
            });
        }
    });
}

function reinsurancePanelWidth() {
    var isTablet = window.matchMedia("(max-width: 768px)").matches;
    var windowWidth = window.innerWidth;
    var $panelWrapper = $('.reinsurance-panel .panel-wrapper');
    var $productDetailsWrapper = $('.reinsurance-panel .product-details-wrapper');

    if (isTablet) {
        $panelWrapper.css({ width: windowWidth, right: -windowWidth });
        $productDetailsWrapper.css({ width: windowWidth });
    } else {
        $panelWrapper.css({ width: '', right: '' });
        $productDetailsWrapper.css({ width: '' });
    }
}

function reinsuranceContent() {
    const $reinsuranceWrapper = $('.reinsurance-wrapper');
    $reinsuranceWrapper.each(function () {
        $('.reinsurance-wrapper.open-reinsurance-panel').on('ready', function () {
            const element = $(this);
            element.prop("disabled", false);
            element.find('.description-icon').removeClass('hide');
            element.find('.reinsurance-content svg').removeClass('remove-svg-margin');
        });
    });
    $('#main, #quickview-modal').on('click', '.reinsurance-wrapper', function (e) {
        e.stopImmediatePropagation();
        const $this = $(this);
        const clickedIndex = $(".reinsurance-wrapper").index(this);
        if ($this.hasClass("open-reinsurance-panel")) {
            $this.prop("disabled", false);
            const contentAssetId = $this.attr("data-content-id")
            openReinsurancePanel(contentAssetId);
            analytics.reinsurancePDPDatalayer($this, clickedIndex);
        } else {
            $this.find('.reinsuranceDesc').toggleClass('open');
            $this.find('.plus-icon').toggleClass('hide');
            $this.find('.minus-icon').toggleClass('show');
            $this.siblings().toggleClass('hidden');
            $this.find('.reinsurance-content').toggleClass('adjust-margin-content');
            $this.toggleClass('reinsurance-margin');
        }
    });
    $reinsuranceWrapper.on('ready', function () {
        $reinsuranceWrapper.each(function () {
            const $this = $(this);
            if ($this.find('.reinsuranceDesc').length === 0) {
                $this.find('.description-icon').addClass('hide');
                $this.find('.reinsurance-content svg').addClass('remove-svg-margin');
                $this.css("cursor", "default");
                $this.prop("disabled", true);
            }
        });
    });
}
// End of reinsurance popup

function reinsurancePanelHandlerPdp() {
    if ($('.reinsurance-panel').length > 0) {
        checkoutReinsurancePopup();
        reinsuranceContent();
        closeReinsurance();
        handleReinsuranceButtons();
        reinsurancePanelWidth();
    }
}

export default {
    reinsuranceWrapperReady: reinsuranceWrapperReady,
    reinsuranceCartClickEvent: reinsuranceCartClickEvent,
    reinsuranceCartOnDocumentReady: reinsuranceCartOnDocumentReady,
    reinsuranceCartOnLoad: reinsuranceCartOnLoad,
    reinsuranceCartClickResize: reinsuranceCartClickResize,
    reinsurancePanelHandlerPdp: reinsurancePanelHandlerPdp,
    reinsurancePanelWidth : reinsurancePanelWidth
}
